import { render, staticRenderFns } from "./serviceSheet.vue?vue&type=template&id=52c35fa0&scoped=true"
import script from "./serviceSheet.vue?vue&type=script&lang=js"
export * from "./serviceSheet.vue?vue&type=script&lang=js"
import style0 from "./serviceSheet.vue?vue&type=style&index=0&id=52c35fa0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c35fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c35fa0')) {
      api.createRecord('52c35fa0', component.options)
    } else {
      api.reload('52c35fa0', component.options)
    }
    module.hot.accept("./serviceSheet.vue?vue&type=template&id=52c35fa0&scoped=true", function () {
      api.rerender('52c35fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/serviceSheet.vue"
export default component.exports